export default "__VITE_ASSET__BNVCjyjg__"